import $ from 'jquery';

function setAspectRatioToImg(node) {
  $(node).find('img').each(function () {
      const w = $(this).attr('width');
      const h = $(this).attr('height');
      if (w && h) {
        $(this).css('aspect-ratio', w + '/' + h);
      }
  });
}

export default setAspectRatioToImg;
